import React, { useContext, useState } from 'react';
import { ToolOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import DeviceContext from '@totem/components/devices/devicesContainer/deviceContainerContext';
import MaintenanceWindowDialog from '@totem/components/devices/devicesContainer/MaintenanceWindowDialog';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull, isNull } from '@totem/utilities/common';

const MaintenanceWindowButton = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { loading, selectedDevices } = useContext(DeviceContext);
  const [showMaintenanceWindowDialog, setShowMaintenanceWindowDialog] =
    useState(false);
  const canCreateMaintenanceWindows =
    permissions.teamMember.hasPermissions(userProfile);

  return (
    <>
      <IBTooltip content={permissions.teamMember.tooltip}>
        <Button
          icon={<ToolOutlined />}
          disabled={
            !canCreateMaintenanceWindows ||
            loading ||
            isNull(selectedDevices) ||
            selectedDevices.length < 1
          }
          onClick={() => setShowMaintenanceWindowDialog(true)}
        >
          Create Maintenance Window{' '}
          {isNotNull(selectedDevices) && selectedDevices.length > 0
            ? ` (${selectedDevices.length})`
            : ''}
        </Button>
      </IBTooltip>
      {showMaintenanceWindowDialog && (
        <MaintenanceWindowDialog
          mode={'edit'}
          onClose={() => setShowMaintenanceWindowDialog(false)}
          open={showMaintenanceWindowDialog}
        />
      )}
    </>
  );
};

export default MaintenanceWindowButton;
